module.exports = require("babel-runtime/helpers/newArrowCheck");


//////////////////
// WEBPACK FOOTER
// external "babel-runtime/helpers/newArrowCheck"
// module id = 2
// module chunks = 0